// src/data/translations.js
export const translations = {
  // =============================================
  // ESPAÑOL
  // =============================================
  esp: {
    header: {
      nosotros: "Nosotros",
      servicios: "Servicios",
      iniciarSesion: "Iniciar Sesión",
      perfil: "Mi Perfil",
      menuAcciones: "Mis Acciones",
      menuAsambleas: "Mis Asambleas",
      menuPoderesRecibidos: "Poderes Recibidos",
      cerrarSesion: "Cerrar Sesión",
      admin: "Administración"
    },
    hero: {
      subtitle: "WISBY LEGAL TECH",
      title: "TU SEGURIDAD LEGAL, SIEMPRE A LA MANO",
      description: "Soluciones legales digitales para proteger tu empresa y patrimonio de forma rápida, segura y accesible.",
      button: "Crea tu acción",
      scroll: "Scroll"
    },
    about: {
      sectionLabel: "SOBRE NOSOTROS",
      quote: "Fusionamos la certeza del marco legal con una visión de negocio estratégica, ofreciendo soluciones integrales que protegen y potencian el valor de tu patrimonio en un entorno digital seguro.",
      title: "ABRIENDO NUEVOS HORIZONTES",
      p1: "En Wisby, creamos estructuras legales y corporativas robustas que permiten a nuestros clientes navegar con confianza en mercados complejos.",
      p2: "Desarrollamos soluciones preventivas y correctivas a través de un profundo conocimiento del derecho y una interacción proactiva con los grupos de interés.",
      stats: {
        clients: "Clientes Satisfechos",
        experience: "Años de Experiencia",
        success: "Tasa de Éxito"
      }
    },
    companies: {
      title: "EMPRESAS QUE CONFÍAN EN NOSOTROS"
    },
    testimonials: {
      title: "Lo que dicen nuestros clientes",
      items: [
        { text: "En Wisby, creamos estructuras legales y corporativas robustas que permiten a nuestros clientes navegar con confianza en mercados complejos.", name: "Sofía Hernández", company: "Directora General, InnovaTech" },
        { text: "Desarrollamos soluciones preventivas y correctivas a través de un profundo conocimiento del derecho, garantizando la integridad en cada transacción.", name: "Alejandro Torres", company: "CFO, Finanzas Futuras" },
        { text: "La digitalización de nuestros activos fue impecable. Su plataforma es segura, intuitiva y cumple con toda la normativa vigente.", name: "Mariana Ramírez", company: "CEO, Quantum Logística" },
        { text: "El acompañamiento legal que recibimos fue proactivo y estratégico. Se anticiparon a cada posible contingencia.", name: "Javier Morales", company: "Fundador, Constructora Muro" },
        { text: "Fusionan la certeza legal con una visión de negocio que realmente potencia el valor de tu patrimonio.", name: "Valeria Castillo", company: "Gerente de Operaciones, Soluciones Médicas" },
        { text: "La transparencia y la integridad son sus pilares. Cada paso del proceso fue claro y nos sentimos protegidos.", name: "Ricardo Mendoza", company: "Socio Director, Agroexportadores del Norte" }
      ]
    },
    auth: {
      loginTitle: "INICIO DE SESIÓN",
      registerTitle: "CREAR CUENTA",
      email: "CORREO ELECTRÓNICO*",
      password: "CONTRASEÑA*",
      confirmEmail: "CONFIRMAR CORREO*",
      confirmPassword: "CONFIRMAR CONTRASEÑA*",
      name: "NOMBRE(S)*",
      lastName: "APELLIDO(S)*",
      phone: "TELÉFONO*",
      noAccount: "¿Aún no tienes cuenta?",
      createHere: "CREA TU CUENTA AQUÍ",
      haveAccount: "¿Ya tienes una cuenta?",
      loginHere: "INICIA SESIÓN AQUÍ",
      btnLogin: "Iniciar sesión",
      btnRegister: "Crear Cuenta",
      accept: "Acepto el",
      privacy: "Aviso de Privacidad",
      and: "y los",
      terms: "Términos y Condiciones*",
      passReq1: "Mínimo 8 caracteres.",
      passReq2: "Mínimo 1 número.",
      passReq3: "Mínimo 1 mayúscula y 1 minúscula.",
      errorMatch: "Los campos no coinciden.",
      errorEmpty: "Por favor completa todos los campos.",
      rememberMe: "Recordarme"
    },
    nosotrosPage: {
      title: "EXPERTOS EN LA LEY, CON TRAYECTORIA SÓLIDA",
      button: "Quién está detrás",
      introTitle: "NUESTRA FIRMA",
      introText: "En Wisby transformamos la complejidad legal en soluciones claras. Nos dedicamos a proteger los intereses de nuestros clientes con un enfoque estratégico, ético y orientado a resultados.",
      valuesTitle: "NUESTROS VALORES",
      values: [
        { title: "INTEGRIDAD", desc: "Actuamos con honestidad y transparencia en cada caso que tomamos." },
        { title: "EXCELENCIA", desc: "Buscamos la perfección en cada detalle de nuestro trabajo legal." },
        { title: "COMPROMISO", desc: "Nos dedicamos completamente a los intereses de nuestros clientes." }
      ],
      teamTitle: "NUESTRO EQUIPO",
      lawyer1: {
        name: "Carlos Mendoza García",
        role: "Socio Fundador",
        desc: "Con más de 20 años de experiencia en derecho corporativo y litigios comerciales, Carlos ha liderado casos emblemáticos que han sentado precedentes en la industria.",
        areas: ["Derecho Corporativo", "Litigio Comercial", "Fusiones"]
      },
      lawyer2: {
        name: "María Elena Rodríguez",
        role: "Socia Fundadora",
        desc: "Especialista en derecho civil y resolución de conflictos, María Elena aporta una perspectiva única que combina rigor analítico con sensibilidad humana.",
        areas: ["Derecho Civil", "Resolución de Conflictos", "Derecho Familiar"]
      },
      stats: [
        { number: "500+", label: "Casos Exitosos" },
        { number: "98%", label: "Clientes Satisfechos" },
        { number: "20+", label: "Años de Experiencia" }
      ],
      ctaTitle: "¿LISTO PARA TRABAJAR CON NOSOTROS?",
      ctaButton: "Contáctanos",
      viewLinkedIn: "Ver en LinkedIn"
    },
    acciones: {
      title: "Crea una Nueva Acción",
      companyName: "Nombre de la Compañía",
      state: "Estado de Constitución",
      goToDesign: "Ir a Diseñar Acción",
      placeholderState: "Selecciona un estado...",
      // basic: "Básico", // ✅ Removido
      // premium: "Premium 👑", // ✅ Removido
      chooseDesign: "Diseño",
      chooseLogo: "Logo",
      chooseMembrete: "Membrete",
      font: "Fuente",
      textSize: "Tamaño del Texto",
      preview: "Vista Previa",
      tools: "Herramientas",
      viewFront: "Ver Anverso",
      viewBack: "Ver Reverso",
      viewTickets: "Ver Tickets",
      back: "Volver",
      sendPay: "Enviar y Pagar",
      stepFinal: "Estás a un solo paso de finalizar",
      stepDesc: "Elige una opción para continuar. Tu diseño actual se guardará.",
      plans: {
        // basicTitle: "Plan Básico", // ✅ Removido
        // basicDesc: "Análisis legal, Diseño Básico, Impresión.", // ✅ Removido
        // premiumTitle: "Plan Premium", // ✅ Removido
        // premiumDesc: "Diseño Premium, Sellos de Seguridad e Impresión." // ✅ Removido
      },
      shipping: {
        title: "Información de Envío",
        note: "El envío es gratuito a cualquier parte de la república.",
        name: "Nombre Completo",
        address: "Dirección (Calle, Número, Colonia)",
        state: "Estado",
        city: "Ciudad / Municipio",
        zip: "Código Postal"
      },
      payment: {
        title: "Información de Pago",
        name: "Nombre en la Tarjeta",
        number: "Número de Tarjeta",
        expiry: "Expiración (MM/YY)",
        cvc: "CVC",
        payButton: "Pagar"
      },
      confirmation: {
        title: "¡Gracias por tu compra!",
        received: "Hemos recibido tu pedido y lo estamos preparando.",
        delivery: "Tu pedido será entregado aproximadamente el",
        emailCheck: "Revisa tu bandeja de entrada para ver el desglose completo.",
        accept: "Aceptar"
      }
    },
    profile: {
      backHome: "Volver al Inicio",
      myShares: "Mis Acciones",
      myAssemblies: "Asambleas",
      noShares: "No has creado acciones",
      noSharesDesc: "Cuando diseñes y finalices tu primera acción, aparecerá aquí.",
      createFirst: "Crear mi primera acción",
      viewBoleta: "Ver Boleta",
      comingSoon: "Próximamente",
      comingSoonDesc: "La sección de Asambleas estará disponible pronto."
    },
    footer: {
      solutions: "SOLUCIONES",
      createShares: "CREACIÓN DE ACCIONES",
      contracts: "CONTRATOS DIGITALES",
      trademark: "REGISTRO DE MARCA",
      consultancy: "ASESORÍAS",
      legalHelp: "ACOMPAÑAMIENTO LEGAL",
      about: "NOSOTROS",
      aboutWisby: "SOBRE WISBY",
      partners: "NUESTROS SOCIOS"
    },
    legal: {
      termsTitle: "Términos y Condiciones",
      privacyTitle: "Aviso de Privacidad",
      lastUpdate: "Última actualización",
      backToHome: "Volver al Inicio",
      backToRegister: "Volver al registro",
      acceptButton: "He leído y acepto"
    },
    vision: {
      statement: "Fusionamos la certeza del marco legal con una visión de negocio estratégica, ofreciendo soluciones integrales que protegen y potencian el valor de su patrimonio en un entorno digital seguro.",
      title: "ABRIENDO NUEVOS HORIZONTES",
      p1: "En TCH, creamos estructuras legales y corporativas robustas que permiten a nuestros clientes navegar con confianza en mercados complejos. Nos especializamos en la digitalización de activos, asegurando que cada certificado, título o acción no solo cumpla con la normativa vigente, sino que también esté preparado para las oportunidades del futuro.",
      p2: "Desarrollamos soluciones preventivas y correctivas a través de un profundo conocimiento del derecho y una interacción proactiva con los grupos de interés, garantizando la integridad y transparencia en cada transacción."
    }
  },

  // =============================================
  // ENGLISH
  // =============================================
  eng: {
    header: {
      nosotros: "About Us",
      servicios: "Services",
      iniciarSesion: "Log In",
      perfil: "My Profile",
      menuAcciones: "My Shares",
      menuAsambleas: "My Assemblies",
      menuPoderesRecibidos: "Received Powers",
      cerrarSesion: "Log Out",
      admin: "Administration"
    },
    hero: {
      subtitle: "WISBY LEGAL TECH",
      title: "YOUR LEGAL SECURITY, ALWAYS AT HAND",
      description: "Digital legal solutions to protect your business and assets quickly, securely, and affordably.",
      button: "Create your share",
      scroll: "Scroll"
    },
    about: {
      sectionLabel: "ABOUT US",
      quote: "We merge the certainty of the legal framework with a strategic business vision, offering comprehensive solutions that protect and enhance the value of your assets in a secure digital environment.",
      title: "OPENING NEW HORIZONS",
      p1: "At Wisby, we create robust legal and corporate structures that allow our clients to navigate complex markets with confidence.",
      p2: "We develop preventive and corrective solutions through deep legal knowledge and proactive stakeholder interaction.",
      stats: {
        clients: "Satisfied Clients",
        experience: "Years of Experience",
        success: "Success Rate"
      }
    },
    companies: {
      title: "COMPANIES THAT TRUST US"
    },
    testimonials: {
      title: "What our clients say",
      items: [
        { text: "At Wisby, we create robust legal and corporate structures that allow clients to navigate complex markets with confidence.", name: "Sofía Hernández", company: "CEO, InnovaTech" },
        { text: "We develop preventive and corrective solutions through deep legal knowledge, guaranteeing integrity in every transaction.", name: "Alejandro Torres", company: "CFO, Future Finance" },
        { text: "The digitization of our assets was flawless. Their platform is secure, intuitive, and complies with all current regulations.", name: "Mariana Ramírez", company: "CEO, Quantum Logistics" },
        { text: "The legal support we received was proactive and strategic. They anticipated every possible contingency.", name: "Javier Morales", company: "Founder, Muro Construction" },
        { text: "They merge legal certainty with a business vision that truly enhances the value of your assets.", name: "Valeria Castillo", company: "Operations Manager, Medical Solutions" },
        { text: "Transparency and integrity are their pillars. Every step of the process was clear and we felt protected.", name: "Ricardo Mendoza", company: "Managing Partner, Northern Agroexporters" }
      ]
    },
    auth: {
      loginTitle: "LOG IN",
      registerTitle: "CREATE ACCOUNT",
      email: "EMAIL ADDRESS*",
      password: "PASSWORD*",
      confirmEmail: "CONFIRM EMAIL*",
      confirmPassword: "CONFIRM PASSWORD*",
      name: "FIRST NAME(S)*",
      lastName: "LAST NAME(S)*",
      phone: "PHONE*",
      noAccount: "Don't have an account yet?",
      createHere: "CREATE YOUR ACCOUNT HERE",
      haveAccount: "Already have an account?",
      loginHere: "LOG IN HERE",
      btnLogin: "Log In",
      btnRegister: "Create Account",
      accept: "I accept the",
      privacy: "Privacy Policy",
      and: "and the",
      terms: "Terms and Conditions*",
      passReq1: "Minimum 8 characters.",
      passReq2: "Minimum 1 number.",
      passReq3: "Minimum 1 uppercase and 1 lowercase.",
      errorMatch: "Fields do not match.",
      errorEmpty: "Please fill in all fields.",
      rememberMe: "Remember me"
    },
    nosotrosPage: {
      title: "LEGAL EXPERTS WITH SOLID TRAJECTORY",
      button: "Who is behind",
      introTitle: "OUR FIRM",
      introText: "At Wisby we transform legal complexity into clear solutions. We are dedicated to protecting our clients' interests with a strategic, ethical and results-oriented approach.",
      valuesTitle: "OUR VALUES",
      values: [
        { title: "INTEGRITY", desc: "We act with honesty and transparency in every case we take." },
        { title: "EXCELLENCE", desc: "We seek perfection in every detail of our legal work." },
        { title: "COMMITMENT", desc: "We are completely dedicated to our clients' interests." }
      ],
      teamTitle: "OUR TEAM",
      lawyer1: {
        name: "Carlos Mendoza García",
        role: "Founding Partner",
        desc: "With more than 20 years of experience in corporate law and commercial litigation, Carlos has led landmark cases that have set precedents in the industry.",
        areas: ["Corporate Law", "Commercial Litigation", "Mergers"]
      },
      lawyer2: {
        name: "María Elena Rodríguez",
        role: "Founding Partner",
        desc: "Specialist in civil law and conflict resolution, María Elena brings a unique perspective that combines analytical rigor with human sensitivity.",
        areas: ["Civil Law", "Conflict Resolution", "Family Law"]
      },
      stats: [
        { number: "500+", label: "Successful Cases" },
        { number: "98%", label: "Satisfied Clients" },
        { number: "20+", label: "Years of Experience" }
      ],
      ctaTitle: "READY TO WORK WITH US?",
      ctaButton: "Contact Us",
      viewLinkedIn: "View on LinkedIn"
    },
    acciones: {
      title: "Create a New Share",
      companyName: "Company Name",
      state: "State of Incorporation",
      goToDesign: "Go to Design Share",
      placeholderState: "Select a state...",
      // basic: "Basic", // ✅ Removido
      // premium: "Premium 👑", // ✅ Removido
      chooseDesign: "Design",
      chooseLogo: "Logo",
      chooseMembrete: "Letterhead",
      font: "Font",
      textSize: "Text Size",
      preview: "Preview",
      tools: "Tools",
      viewFront: "View Front",
      viewBack: "View Back",
      viewTickets: "View Tickets",
      back: "Back",
      sendPay: "Send and Pay",
      stepFinal: "You are one step away from finishing",
      stepDesc: "Choose an option to continue. Your current design will be saved.",
      plans: {
        // basicTitle: "Basic Plan", // ✅ Removido
        // basicDesc: "Legal analysis, Basic Design, Printing.", // ✅ Removido
        // premiumTitle: "Premium Plan", // ✅ Removido
        // premiumDesc: "Premium Design, Security Seals and Printing." // ✅ Removido
      },
      shipping: {
        title: "Shipping Information",
        note: "Shipping is free to any part of the republic.",
        name: "Full Name",
        address: "Address (Street, Number, Neighborhood)",
        state: "State",
        city: "City / Municipality",
        zip: "Zip Code"
      },
      payment: {
        title: "Payment Information",
        name: "Name on Card",
        number: "Card Number",
        expiry: "Expiry (MM/YY)",
        cvc: "CVC",
        payButton: "Pay"
      },
      confirmation: {
        title: "Thank you for your purchase!",
        received: "We have received your order and are preparing it.",
        delivery: "Your order will be delivered approximately on",
        emailCheck: "Check your inbox for full details.",
        accept: "Accept"
      }
    },
    profile: {
      backHome: "Back to Home",
      myShares: "My Shares",
      myAssemblies: "Assemblies",
      noShares: "You haven't created shares yet",
      noSharesDesc: "When you design and finalize your first share, it will appear here.",
      createFirst: "Create my first share",
      viewBoleta: "View Certificate",
      comingSoon: "Coming Soon",
      comingSoonDesc: "The Assemblies section will be available soon."
    },
    footer: {
      solutions: "SOLUTIONS",
      createShares: "SHARE CREATION",
      contracts: "DIGITAL CONTRACTS",
      trademark: "TRADEMARK REGISTRATION",
      consultancy: "CONSULTANCY",
      legalHelp: "LEGAL SUPPORT",
      about: "ABOUT US",
      aboutWisby: "ABOUT WISBY",
      partners: "OUR PARTNERS"
    },
    legal: {
      termsTitle: "Terms and Conditions",
      privacyTitle: "Privacy Policy",
      lastUpdate: "Last updated",
      backToHome: "Back to Home",
      backToRegister: "Back to registration",
      acceptButton: "I have read and accept"
    },
    vision: {
      statement: "We merge the certainty of the legal framework with a strategic business vision, offering comprehensive solutions that protect and enhance the value of your assets in a secure digital environment.",
      title: "OPENING NEW HORIZONS",
      p1: "At TCH, we create robust legal and corporate structures that allow our clients to navigate complex markets with confidence. We specialize in the digitization of assets, ensuring that each certificate, title or share not only complies with current regulations, but is also prepared for future opportunities.",
      p2: "We develop preventive and corrective solutions through deep legal knowledge and proactive stakeholder interaction, guaranteeing integrity and transparency in every transaction."
    }
  },

  // =============================================
  // 中文 (CHINESE)
  // =============================================
  zh: {
    header: {
      nosotros: "关于我们",
      servicios: "服务",
      iniciarSesion: "登录",
      perfil: "我的资料",
      menuAcciones: "我的股份",
      menuAsambleas: "我的会议",
      menuPoderesRecibidos: "收到的授权书",
      cerrarSesion: "注销",
      admin: "管理"
    },
    hero: {
      subtitle: "WISBY 法律科技",
      title: "您的法律安全，尽在掌握",
      description: "数字法律解决方案，快速、安全、经济地保护您的企业和资产。",
      button: "创建您的股份",
      scroll: "滚动"
    },
    about: {
      sectionLabel: "关于我们",
      quote: "我们将法律框架的确定性与战略性商业眼光相结合，提供全面的解决方案，在安全的数字环境中保护和提升您资产的价值。",
      title: "开创新视野",
      p1: "在Wisby，我们创建强大的法律和公司结构，使我们的客户能够自信地驾驭复杂的市场。",
      p2: "我们通过对法律的深刻理解以及与利益相关者的积极互动，制定预防性和纠正性解决方案。",
      stats: {
        clients: "满意客户",
        experience: "年经验",
        success: "成功率"
      }
    },
    companies: {
      title: "信任我们的公司"
    },
    testimonials: {
      title: "客户评价",
      items: [
        { text: "在Wisby，我们创建强大的法律和公司结构，使客户能够自信地驾驭复杂的市场。", name: "Sofía Hernández", company: "总经理, InnovaTech" },
        { text: "我们通过对法律的深刻理解开发预防性和纠正性解决方案，确保每笔交易的完整性。", name: "Alejandro Torres", company: "财务总监, Future Finance" },
        { text: "我们资产的数字化完美无瑕。他们的平台安全、直观，并符合所有现行法规。", name: "Mariana Ramírez", company: "首席执行官, Quantum Logistics" },
        { text: "我们收到的法律支持积极且具有战略意义。他们预见了每一个可能的突发事件。", name: "Javier Morales", company: "创始人, Muro Construction" },
        { text: "他们将法律确定性与真正提升您资产价值的商业愿景完美融合。", name: "Valeria Castillo", company: "运营经理, Medical Solutions" },
        { text: "透明和诚信是他们的支柱。过程的每一步都很清晰，我们感到受到保护。", name: "Ricardo Mendoza", company: "管理合伙人, Northern Agroexporters" }
      ]
    },
    auth: {
      loginTitle: "登录",
      registerTitle: "创建账户",
      email: "电子邮件*",
      password: "密码*",
      confirmEmail: "确认电子邮件*",
      confirmPassword: "确认密码*",
      name: "名字*",
      lastName: "姓氏*",
      phone: "电话*",
      noAccount: "还没有账户？",
      createHere: "在此创建账户",
      haveAccount: "已有账户？",
      loginHere: "在此登录",
      btnLogin: "登录",
      btnRegister: "创建账户",
      accept: "我接受",
      privacy: "隐私声明",
      and: "和",
      terms: "条款和条件*",
      passReq1: "最少8个字符。",
      passReq2: "最少1个数字。",
      passReq3: "最少1个大写字母和1个小写字母。",
      errorMatch: "字段不匹配。",
      errorEmpty: "请填写所有字段。",
      rememberMe: "记住我"
    },
    nosotrosPage: {
      title: "法律专家，业绩稳固",
      button: "幕后团队",
      introTitle: "我们的公司",
      introText: "在Wisby，我们将复杂的法律问题转化为清晰的解决方案。我们致力于以战略性、道德性和结果导向的方式保护客户的利益。",
      valuesTitle: "我们的价值观",
      values: [
        { title: "诚信", desc: "我们在每个案例中都以诚实和透明的方式行事。" },
        { title: "卓越", desc: "我们在法律工作的每个细节中追求完美。" },
        { title: "承诺", desc: "我们全心全意地致力于客户的利益。" }
      ],
      teamTitle: "我们的团队",
      lawyer1: {
        name: "Carlos Mendoza García",
        role: "创始合伙人",
        desc: "在公司法和商业诉讼方面拥有超过20年的经验，Carlos领导了在行业中树立先例的标志性案例。",
        areas: ["公司法", "商业诉讼", "并购"]
      },
      lawyer2: {
        name: "María Elena Rodríguez",
        role: "创始合伙人",
        desc: "民法和冲突解决专家，María Elena带来了独特的视角，将分析严谨性与人文敏感性相结合。",
        areas: ["民法", "冲突解决", "家庭法"]
      },
      stats: [
        { number: "500+", label: "成功案例" },
        { number: "98%", label: "满意客户" },
        { number: "20+", label: "年经验" }
      ],
      ctaTitle: "准备好与我们合作了吗？",
      ctaButton: "联系我们",
      viewLinkedIn: "在LinkedIn上查看"
    },
    acciones: {
      title: "创建新股份",
      companyName: "公司名称",
      state: "成立州",
      goToDesign: "去设计股份",
      placeholderState: "选择一个州...",
      basic: "基础",
      premium: "高级 👑",
      chooseDesign: "选择设计",
      chooseLogo: "选择标志",
      chooseMembrete: "选择信头",
      font: "字体",
      textSize: "文字大小",
      preview: "预览",
      tools: "工具",
      viewFront: "查看正面",
      viewBack: "查看背面",
      viewTickets: "查看票据",
      back: "返回",
      sendPay: "发送并支付",
      stepFinal: "只差最后一步",
      stepDesc: "选择一个选项继续。您当前的设计将被保存。",
      plans: {
        basicTitle: "基础计划",
        basicDesc: "法律分析，基础设计，打印。",
        premiumTitle: "高级计划",
        premiumDesc: "高级设计，安全印章和打印。"
      },
      shipping: {
        title: "送货信息",
        note: "共和国任何地方均免费送货。",
        name: "全名",
        address: "地址",
        state: "州",
        city: "城市",
        zip: "邮政编码"
      },
      payment: {
        title: "付款信息",
        name: "持卡人姓名",
        number: "卡号",
        expiry: "有效期",
        cvc: "CVC",
        payButton: "支付"
      },
      confirmation: {
        title: "感谢您的购买！",
        received: "我们已收到您的订单并正在准备中。",
        delivery: "您的订单大约将于以下日期送达",
        emailCheck: "查看收件箱以获取详细信息。",
        accept: "接受"
      }
    },
    profile: {
      backHome: "返回首页",
      myShares: "我的股份",
      myAssemblies: "会议",
      noShares: "您尚未创建股份",
      noSharesDesc: "当您设计并完成第一份股份时，它将显示在这里。",
      createFirst: "创建我的第一份股份",
      viewBoleta: "查看证书",
      comingSoon: "即将推出",
      comingSoonDesc: "会议部分即将推出。"
    },
    footer: {
      solutions: "解决方案",
      createShares: "股份创建",
      contracts: "数字合同",
      trademark: "商标注册",
      consultancy: "咨询",
      legalHelp: "法律支持",
      about: "关于我们",
      aboutWisby: "关于 WISBY",
      partners: "我们的合作伙伴"
    },
    legal: {
      termsTitle: "条款和条件",
      privacyTitle: "隐私政策",
      lastUpdate: "最后更新",
      backToHome: "返回首页",
      backToRegister: "返回注册",
      acceptButton: "我已阅读并接受"
    },
    vision: {
      statement: "我们将法律框架的确定性与战略性商业眼光相结合，提供全面的解决方案，在安全的数字环境中保护和提升您资产的价值。",
      title: "开创新视野",
      p1: "在TCH，我们创建强大的法律和公司结构，使我们的客户能够自信地驾驭复杂的市场。我们专注于资产数字化，确保每份证书、产权或股份不仅符合现行法规，而且为未来的机会做好准备。",
      p2: "我们通过对法律的深刻理解以及与利益相关者的积极互动，制定预防性和纠正性解决方案，确保每笔交易的完整性和透明度。"
    }
  }
};
